import React from 'react';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from 'antd';
import './spinner.sass';

const { Title } = Typography;

// Componente personalizado de spinner (efecto loading con ruedecita)
const Spinner = () => {
  return (
    <div className="loader">
      <div className="center">
        <FontAwesomeIcon
          className="spinner"
          icon={ faSpinner }
        />
        <Title className="text-spinner">Loader...</Title>
      </div>
    </div>
  );
}

export default Spinner;
